module.exports = __webpack_public_path__ + "img/logo-big-atu.af9d66fa.png";